// OvniMerged.jsx
import { useSceneRef } from "../../../RefsProvider"
import { BallCollider, RigidBody } from "@react-three/rapier"
import Ovni from "../../Three/models/Ovni"


export default function OvniMerged() {
    const refOvni = useSceneRef("ovni")
    const refOvniVisual = useSceneRef("ovniVisual") 

    return (
        <RigidBody
            ref={refOvni}
            type="dynamic"
            gravityScale={0}
            linearDamping={2}    
            angularDamping={4}   
            colliders={false}
            position={[0, 4, 0]}
            lockRotations
        >
            <group ref={refOvniVisual}>
                <mesh position={[0, 1.2, 0]}>
                    <sphereGeometry args={[1.2, 32, 32]} />
                    <meshPhysicalMaterial
                        roughness={0}
                        metalness={0.0}
                        thickness={0.1}
                        transmission={1.0}
                        ior={1}
                        clearcoat={1.0}
                        clearcoatRoughness={0.4}
                        specularIntensity={0}
                        sheen={1}
                        sheenColor={"#0e454b"}
                    />
                </mesh>
                <Ovni scale={0.01} />
            </group>

            <BallCollider
                args={[1.5]}
                restitution={0.4} 
                friction={0.2}
                position={[0,1,0]}
            />
        </RigidBody>

    )
}
